/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/* eslint-disable @typescript-eslint/ban-types */
import createMethodDecorator from 'apmui/util/createMethodDecorator';

const bindImpl = createMethodDecorator('bind', (target, fn) => fn.bind(target));
/**
 * The @bind decorator binds method to an instance of current object.
 * @example
 * ```
 *
 * class SomeClass {
 *   constructor() {
 *      this.method.call(null);
 *   }
 *
 *   @bind
 *   method() {
 *      console.log(this);
 *   }
 * }
 * ```
 */
function bind<T>(
    target: Object,
    key: string | symbol,
    descriptor: TypedPropertyDescriptor<T>
): void | TypedPropertyDescriptor<T>;
/**
 * The @bind decorator binds method to an instance of current object.
 * @example
 * ```
 *
 * class SomeClass {
 *   constructor() {
 *      this.method.call(null);
 *   }
 *
 *   @bind()
 *   method() {
 *      console.log(this);
 *   }
 * }
 * ```
 */
function bind(): MethodDecorator;

function bind(this: any, target?: Object, key?: string | symbol, descriptor?: any) {
    if (target && key && descriptor) {
        return bindImpl.call(this, target, key, descriptor);
    } else {
        return bindImpl;
    }
}

export default bind;
